import { render, staticRenderFns } from "./GlobalDialogSlot.vue?vue&type=template&id=48e5cd00"
import script from "./GlobalDialogSlot.vue?vue&type=script&lang=js"
export * from "./GlobalDialogSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports